export default "__VITE_ASSET__CsHv8sNT__"